<template>
  <div class="enterprise-list-page enterprise-list-page--donors">
    <!-- Header Card -->
        <PageHeader icon="fas fa-hand-holding-medical">
      <template #title>
        Daftar Pendonor Darah {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola data sukarelawan pendonor darah beserta riwayat dan golongan darahnya
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/donors/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Pendonor</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <modern-filter-bar
              embedded
              single-line
              :show-timeseries="false"
              :search-text.sync="filter.name"
              search-placeholder="Cari nama pendonor"
              @search-keyup="filterByName"
            >
              <template #before-search>
                <div class="modern-filter-select">
                  <treeselect
                    v-model="filter.blood_type_id"
                    :multiple="false"
                    :options="blood_type"
                    placeholder="Semua golongan darah"
                    @select="filterByBloodType"
                  />
                </div>
              </template>
            </modern-filter-bar>
            <medhop-data-table summary-title="Daftar Pendonor Darah" striped hover responsive :items="items" :fields="fields">
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '20%' : '' }" />
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({ path: '/donors/detail/' + data.item.id })
                  ">
                  <i class="fas fa-eye px-0"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({ path: '/donors/edit/' + data.item.id })
                  "
                  v-if="btn">
                  <i class="fas fa-edit px-0"></i>
                </b-button>
                <!-- <b-button
                    size="sm"
                    class="btn-danger"
                  > Hapus </b-button> -->
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        name: "",
        blood_type_id: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "blood_type_name",
          label: "Golongan Darah",
          sortable: true,
        },
        {
          key: "age",
          label: "Umur",
          sortable: true,
        },
        {
          key: "gender",
          label: "Jenis Kelamin",
          sortable: true,
        },
        {
          key: "phone",
          label: "Nomor Handphone",
          sortable: false,
        },
        {
          key: "id_card_number",
          label: "No KTP",
          sortable: false,
        },
        {
          key: "quantity",
          label: "Jumlah Kantong Darah",
          sortable: false,
        },
        // {
        //   key: "birt_date",
        //   label: "Tanggal Lahir",
        //   sortable: false,
        // },
        {
          key: "last_donation_date_display",
          label: "Tanggal Terakhir Donor",
          sortable: true,
        },
        {
          ke: "email",
          label: "Email",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
      blood_type: [],
      // User Access
      btn: false,
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    };
  },

  methods: {
    pageOnClick(page) {
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}&blood_type_id=${this.filter.blood_type_id}`;
      let response = await module.paginate(
        `donors`,
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data;
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("donors/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    async getBloodTypeOption() {
      let response = await module.setTreeSelect("blood-types");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.blood_type = response.data;
        this.blood_type.unshift({
          label: "Filter Berdasar Gol. Darah",
          id: "",
          isDisabled: true,
        });
      }
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1
        this.generalFilter()
      }, 500)
    },

    filterByBloodType(evt) {
      this.filter.blood_type_id = evt.id
      this.currentPage = 1
      this.generalFilter()
    },

    generalFilter() {
      this.pagination()
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "2202") {
          this.btn = true
        }
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bank Darah", route: "/blood-bank" },
      { title: "Daftar Pendonor" },
    ]);

    this.pagination();
    this.getBloodTypeOption();
    this.setActiveButton()
  },

  watch: {
    'filter.blood_type_id': function (newVal, oldVal) {
      if (typeof newVal === 'undefined') {
        this.filter.blood_type_id = ''
        this.generalFilter()
      }
    }
  },
};
</script>

<style></style>
